<div class="wrapper" #wrapperEl (scroll)="onScroll()" cdkScrollable>
	<div class="content" #contentEl>
		<ng-content></ng-content>
	</div>
</div>
<div class="button-wrapper scroll-left" [hidden]="!showToLeftArrow" (click)="scrollTo('left')">
	<div class="btn">
		<span><i class="fa fa-arrow-circle-left"></i></span>
	</div>
	<div class="gradient"></div>
</div>
<div class="button-wrapper scroll-right" [hidden]="!showToRightArrow" (click)="scrollTo('right')">
	<div class="gradient"></div>
	<div class="btn">
			<span><i class="fa fa-arrow-circle-right"></i></span>
	</div>
</div>
